import { usePostApiData } from "shared/datalayer";
import CommonApi from "shared/enums/CommonApi";
import { ApiInvoicePaymentRequest } from "shared/types/ApiInvoicePaymentRequest";
import { ApiInvoicePayerPaymentRequest } from "shared/types/ApiInvoicePayerPaymentRequest";

export function useInvoicePayerPaymentRequest() {
  return usePostApiData<ApiInvoicePaymentRequest, ApiInvoicePayerPaymentRequest>(
    CommonApi.PAYMENT_BY_INVOICE_PAYER_REQUEST
  );
}
